<h1>Inbound Loads</h1>

<p-card>

<p-table #dt
    [columns]="cols | async"
    [value]="combinedLoads | async"
    [paginator]="true"
    [rows]="20"
    [autoLayout]="true"
    exportFilename="Inbound Loads"
    sortField="arrivedTimestamp"
    [sortOrder]="-1">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th [attr.colspan]="(cols | async)?.length + 2">
        <div class="load-table-header">
          <div>
            <button pButton type="button" icon="pi pi-plus" (click)="startLoad()" label="Create load"></button>
            <p-toggleButton onLabel="Search"
              offLabel="Cancel Search"
              offIcon="pi pi-times"
              icon="pi pi-search"
              iconPos="left"
              (onChange)="changeSearchStatus()"
              [(ngModel)]="searchFlag"
              class="ml"
              [styleClass]="searchFlag ? 'p-button-secondary' : 'p-state-disabled'">
            </p-toggleButton>
            <button pButton
              class="ml"
              type="button"
              icon="pi pi-file"
              (click)="dt.exportCSV()"
              pTooltip="CSV">
            </button>
          </div>
          <p *ngIf="!searchFlag">Input search criteria to filter; press <code>Enter</code> to search all loads.</p>
          <file-import
            [label]="setImportLabels(site)"
            [fileFormat]="'spreadsheets'"
            (onSelectedLabelChange)="updateSubinventoryFilter($event)"
            (fileUploaded)="refreshLoads()"
            [subinventories]="filteredSubinventories">
          </file-import>
        </div>
      </th>
    </tr>
    <tr>
      <th *ngFor="let col of columns" [pSortableColumn]="col.field" [class]="col.styleClass">
        {{col.header}}
        <p-sortIcon [field]="col.field" [attr.ariaLabel]="col.ariaLabel" [attr.ariaLabelAsc]="col.ariaLabelAsc"
        [attr.ariaLabelDesc]="col.ariaLabelDesc"></p-sortIcon>
      </th>
      <th style="width: 75px;"></th>
      <th></th>
    </tr>
    <tr *ngIf="!searchFlag">
      <th *ngFor="let col of columns" [class]="col.styleClass">
        <p-columnFilter *ngIf="col.type === 'date'" [field]="col.field" [showMenu]="false">
          <ng-template pTemplate="filter" let-value let-filter="dateFilter">
            <p-calendar
              class="gridSearchField"
              appendTo="body"
              [readonlyInput]="true"
              (onSelect)="dt.filter(parseDate($event), col.field, 'dateFilter')"
              (onInput)="filterTable(dt, $event, col.field, 'dateFilter')"
              (keydown.enter)="searchLoad()">
            </p-calendar>
          </ng-template>
        </p-columnFilter>
        <p-columnFilter *ngIf="col.type !== 'date'" (keydown.enter)="searchLoad()"
            [field]="col.field" [showMenu]="false" [matchMode]="'contains'"></p-columnFilter>
          <ng-template pTemplate="filter" let-value let-filter="filterTable">
            <input type="text" pInputText
              [ngModel]="value"
              (ngModelChange)="filter(dt, $event, col.field)"
              (input)="filterTable(dt, $event, col.field)">
          </ng-template>
      </th>
      <th class="buttons"></th>
      <th class="buttons"></th>
    <tr *ngIf="!searchFlag">
      <th [attr.colspan]="(cols | async)?.length + 2">
        <div *ngIf="loading" class="centered">
          <i class="pi pi-spin pi-spinner"></i>
          Searching...
        </div>
        <div *ngIf="hasMoreRows">
          <b>More rows exist. Refine search criteria if necessary to retrieve any loads missing.</b>
        </div>
        <div *ngIf="!loading && !(searchResults | async)?.length">
          <b>No results found for criteria given</b>
        </div>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-load>
    <tr [ngClass]="{'searchResults': fromSearch(load.id), 'dragover': dragged(load.id), 'dropped': dropped(load.id)}"
        (drop)="dropHandler($event)" (dragover)="dragOverHandler($event, load)" (dragleave)="dragLeaveHandler()" [attr.data-id]="load.id">
      <td>{{ load.vendorBolNumber }}</td>
      <td>
        <b>{{load.customer?.accountName}}</b>
        <span *ngIf="!!load.customerSite">
          <span *ngIf="!!load.customerSite?.chepGlobalLocationId"><br/>GLID: {{ load.customerSite?.chepGlobalLocationId }}</span>
        </span>
      </td>
      <td>{{ load.customerSite?.partySiteName }}</td>
      <td>
        <span *ngIf="[InboundLoadStatus.Arrived, InboundLoadStatus.Unloaded, InboundLoadStatus.Processed].includes(load.inboundLoadStatus); else notArrived">
          {{ load.arrivedTimestamp | date: "M/dd/yyyy"}}
        </span>
        <ng-template #notArrived>
          <button pButton
            label="Arrive Load"
            icon="pi pi-arrow-right"
            (click)="arriveLoad(load)">
          </button>
        </ng-template>
      </td>
      <td class="unloadCol">
        <span *ngIf="[InboundLoadStatus.Unloaded, InboundLoadStatus.Processed].includes(load.inboundLoadStatus); else notUnloaded">
          {{ load.unloadedWorkedShift?.date | date: "M/dd/yyyy" }}
          <span class="shiftlbl">{{ load.unloadedWorkedShift?.shift.name }}</span>
        </span>
        <ng-template #notUnloaded>
          <button pButton
            label="Unload Load"
            icon="pi pi-arrow-right"
            (click)="unloadLoad(load)">
          </button>
        </ng-template>
      </td>
      <td *ngIf="showFullWorkflow | async" class="processCol">
        <span *ngIf="!usesFullWorkflow(load); else fullProcessWorkflow">
            (n/a)
        </span>
        <ng-template #fullProcessWorkflow>
          <span *ngIf="[InboundLoadStatus.Processed].includes(load.inboundLoadStatus); else notProcessed">
            {{ load.processedWorkedShift?.date | date: "M/dd/yyyy" }}
            <span class="shiftlbl">{{ load.processedWorkedShift?.shift.name }}</span>
          </span>
          <ng-template #notProcessed>
            <button pButton
              label="Process Load"
              icon="pi pi-arrow-right"
              (click)="processLoad(load)">
            </button>
          </ng-template>
        </ng-template>
      </td>
      <td>{{ load.trailer?.trailerNumber }}</td>
      <td>{{ load.carrier?.carrierName }}</td>
      <td>{{ load.pooler?.accountName }}</td>
      <td>{{ load.totalQuantity }}
        <i (click)="overlayToggle($event, load.inboundLoadLineItems)" class="pi pi-info-circle"></i>
      </td>
      <td class="buttons">
        <button pButton title="Edit" icon="pi pi-pencil" (click)="editLoad(load)">
        </button>
        <confirmation-button
          *ngIf="canDelete"
          [iconsOnly]="true"
          [actionIcon]="'pi pi-times'" actionText="Delete"
          [confirmIcon]="'pi pi-times'" confirmText="Delete"
          cancelIcon="pi pi-minus-circle" cancelText="Cancel"
          (actionConfirmed)="deleteLoad(load)"
          [disabled]="load.unloadedWorkedShift?.shiftStatus == ShiftStatus.Closed || load.processedWorkedShift?.shiftStatus == ShiftStatus.Closed">
        </confirmation-button>
        <button pButton title="Load History" icon="pi pi-book" (click)="showHistoryDialog(load)"></button>
        <button pButton title="Load Files Upload" icon="pi pi-upload" (click)="uploadDocument(load)"></button>
      </td>
      <td class="buttons">
        <p-button type="button" label="Files" title="Load File Upload" icon="pi pi-upload" badge="{{load.documentIds?.length}}" (click)="uploadDocument(load)"></p-button>
      </td>
    </tr>
  </ng-template>
</p-table>
</p-card>

<p-dialog
  class="historyDialog"
  [(visible)]="showHistory"
  header="Load History"
  [blockScroll]="true"
  appendTo="body"
  (onShow)="onShow()"
  (onHide)="onHide()">
  <lib-history
    [label]="historyLoad?.vendorBolNumber"
    [changeHistory]="filteredHistory"
    [actionTemplate]="historyActions"
  >
  </lib-history>
  <ng-template #historyActions>
    <button
      *ngIf="history?.length > 0"
      pButton
      (click)="showMinimalHistory = !showMinimalHistory"
      [pTooltip]="showMinimalHistory ? 'Show all history' : 'Show load and trailer number history'"
      [icon]="showMinimalHistory ? 'pi pi-filter-slash' : 'pi pi-filter'"
  >
  </button>
  </ng-template>
</p-dialog>
<p-dialog
  class="fileStorageDialog"
  [(visible)]="showFileStorageDialog"
  header="File Storage {{uploadLoad?.vendorBolNumber}}"
  [blockScroll]="true"
  [modal]="true"
  [focusTrap]="true"
  appendTo="body">
  <blob-storage
    [label]="'Inbound Documents'"
    [fileTypes]="['Inbound Load']"
    [entityId]="uploadLoad?.id"
    [entityParent]="'InboundLoads'"
    [documentIds]="uploadLoad?.documentIds"
    [siteId]="site?.id">
  </blob-storage>
</p-dialog>

<p-overlayPanel #op
                [style]="{width: '450px'}"
                [showCloseIcon]="true"
                [dismissable]="true"
                appendTo="body">
  <ng-template pTemplate>
    <p-table class="centered overlay" [value]="lineItems">
      <ng-template pTemplate="header">
        <tr>
          <th>Product</th>
          <th>Quantity</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-lineItem>
        <tr>
          <td>{{getProduct(lineItem.productId)}}</td>
          <td>{{lineItem.quantity}}</td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
</p-overlayPanel>

